import { AxiosRequestConfig } from 'axios';
import { ITable } from '../../../../../ApiManager';
import { SearchAnimalUseCase } from './SearchAnimalUseCase';
import { AnimalRepository } from '../../repositories/AnimalRepository';
import { ToPerformRepository } from '../../../toPerform/repositories/ToPerformRepository';
import { IAnimal } from '../../entities/IAnimal';

type Arguments = {
  table: ITable;
  propriedade_id: string;
  config?: AxiosRequestConfig;
};

export async function SearchAnimalController({
  table,
  propriedade_id,
  config,
}: Arguments): Promise<IAnimal[]> {
  const useCase = new SearchAnimalUseCase(
    new AnimalRepository(table.animais),
    new ToPerformRepository(table.toPerform),
  );
  const data = await useCase.execute({ propriedade_id, config });

  return data;
}
